import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Button, Drawer, Flex, Input, Menu } from '@mantine/core';

import { ReactComponent as CheckIcon } from 'assets/check.svg';

import styles from './TagsMenu.module.scss';

interface Props {
  isOpen: boolean;
  triggerButton: React.ReactNode;
  tags: {
    id: number;
    name: string;
    selected: boolean;
  }[];
  isCreateTagMenuOpen: boolean;
  isEditTagsMenuOpen: boolean;
  onOpenCreateTagMenu: () => void;
  onOpenEditTagsMenu: () => void;
  onSubmitTagSelect: (selectedTag: number) => Promise<void>;
  onSubmitTagUnselect: (unselectedTag: number) => Promise<void>;
  onClose: () => void;
}

const TagsMenu = ({ isOpen, triggerButton, tags, isCreateTagMenuOpen, isEditTagsMenuOpen, onOpenCreateTagMenu, onOpenEditTagsMenu, onSubmitTagSelect, onSubmitTagUnselect, onClose }: Props) => {
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [submitError, setSubmitError] = React.useState(false);

  const handleOpenChange = (opened: boolean) => {
    if (!opened) {
      onClose();
    }
  };

  const handleClickOnTag = (index: number) => () => {
    try {
      setIsSubmitting(true);

      if (tags[index].selected) {
        onSubmitTagUnselect(tags[index].id);
      } else {
        onSubmitTagSelect(tags[index].id);
      }

      setSubmitError(false);
    } catch {
      setSubmitError(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Menu
        shadow="md"
        width={350}
        closeOnItemClick={false}
        classNames={{
          dropdown: styles.dropdown,
          label: styles.menuLabel,
          item: styles.menuItem,
        }}
        opened={isOpen && !isCreateTagMenuOpen && !isEditTagsMenuOpen}
        onChange={handleOpenChange}
      >
        <Menu.Target>
          {triggerButton}
        </Menu.Target>

        <Menu.Dropdown>
          <div className={styles.menuHeader}>
            <Menu.Label>Tag Account as:</Menu.Label>
            <Button
              type="button"
              onClick={onClose}
              classNames={{ root: styles.doneButton }}
            >
              DONE
            </Button>
          </div>
          <div className={styles.selectTagArea}>
            {tags.map((tag, index) => (
              <Menu.Item
                key={tag.id}
                leftSection={<CheckIcon style={{ opacity: tag.selected ? 1 : 0 }} />}
                onClick={handleClickOnTag(index)}
                disabled={isSubmitting}
              >
                {tag.name}
              </Menu.Item>
            ))}
          </div>

          <Menu.Divider />

          <div className={styles.actionsArea}>
            <Menu.Item
              className={styles.menuActionItem}
              onClick={onOpenCreateTagMenu}
            >
              Create New Tag +
            </Menu.Item>
            <Menu.Item
              className={styles.menuActionItem}
              onClick={onOpenEditTagsMenu}
            >
              Edit/Delete Tags &gt;
            </Menu.Item>
          </div>
        </Menu.Dropdown>
      </Menu>
    </>
  );
}

export default TagsMenu;
